var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M 62.5 84.375 L 96.875 50 L 62.5 15.625 L 62.5 43.75 L 6.25 43.75 L 6.25 56.25 L 62.5 56.25 Z M 62.5 84.375"}})])}
var staticRenderFns = []

export { render, staticRenderFns }